export default __webpack_public_path__ + "static/media/video-img.a436a30c.jpg";